import { BootComponent, WelcomeComponent } from './boot';
import { PIDsComponent } from './pids';
import { WindowComponent } from './windows';
import { TerminalComponent } from './terminal';
import { ManagerComponent } from './manager';

export const SystemComponents = {
  PIDsComponent, WindowComponent,
  BootComponent, TerminalComponent,
  ManagerComponent, WelcomeComponent
}